import React from 'react';

// Components
import { Layout, Col, Row, Spin } from 'antd';

// Others
import { strings } from '../../localization';

const SplashView = () => (
    <Layout>
        <Layout.Content>
            <Row
                style={{
                    padding: 24,
                    minHeight: '100vh',
                    textAlign: 'center',
                    margin: '30px auto'
                }}
            >
                <Col xs={24} lg={{ span: 24 }}>
                    <Spin size="large" style={{ margin: '30px auto' }} />
                    <h3>{strings.loading}</h3>
                </Col>
            </Row>
        </Layout.Content>
    </Layout>
);

export { SplashView };
